import { render, staticRenderFns } from "./ChatsHeader.vue?vue&type=template&id=6f0b6478&scoped=true&"
import script from "./ChatsHeader.vue?vue&type=script&lang=js&"
export * from "./ChatsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChatsHeader.vue?vue&type=style&index=0&id=6f0b6478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b6478",
  null
  
)

export default component.exports